import { Outlet } from 'react-router-dom'

const Host = () => {
  return (
    <div>
      <Outlet/>
    </div>
  )
}

export default Host